import useViewport from "../../../../hooks/useViewport";
import { ViewportResult } from "../../../../hooks/useViewport/useViewport.types";
import { StyledButtonLabel, StyledMainButton } from "./ProxyBidButton.styles";
import { ProxyBidButtonProps } from "./ProxyBidButton.types";

const ProxyBidButton = ({
	mainButtonDisabled,
	onDelete,
	onApply,
	onReview,
	shouldReviewBid,
	deleteTriggered,
	mainButtonRole,
}: ProxyBidButtonProps) => {
	const viewport: ViewportResult = useViewport();

	const getLabel = () => {
		const isMobileDevice = ["xs", "sm"].includes(viewport?.currentSize);

		if (deleteTriggered) {
			return isMobileDevice ? "Confirm Delete" : "Confirm";
		}

		if (shouldReviewBid) {
			return "Review";
		}

		return isMobileDevice ? "Apply Proxy Bid" : "Apply";
	};

	const handleButtonClick = () => {
		if (deleteTriggered) {
			onDelete();
			return;
		}

		if (shouldReviewBid) {
			onReview();
			return;
		}

		onApply();
	};

	return (
		<StyledMainButton
			viewport={viewport}
			disabled={mainButtonDisabled}
			buttonRole={mainButtonRole}
			onClick={handleButtonClick}
		>
			<StyledButtonLabel
				weight="heaviest"
				position="absolute"
				colorOn="bg_dark"
			>
				{getLabel()}
			</StyledButtonLabel>
		</StyledMainButton>
	);
};
export default ProxyBidButton;
